// 法语
import constant from '../../constants/lang/fr';
import newLang from '../newLang/fr';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: "Veuillez d'abord vous connecter",
        404: 'Aucune donnée',
        500: 'Le système est occupé, veuillez réessayer plus tard',
        504: 'La demande a expiré',
        ERR_NETWORK: 'Exception réseau',
        ERR_NETWORK_UPLOAD: 'Le téléchargement a échoué, veuillez essayer un autre réseau',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'voyant lumineux',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Enregistrement',
        'feedback-create': 'Rétroaction',
        'feedback-supplement': 'Commentaires supplémentaires',
        'feedback-detail': "Détails du retour d'information",
        'feedback-result': 'Rétroaction',
        guide: "centre d'aide",
        'guide-restScreen': 'Installer instructions',
        'guide-overview': 'Aperçu des fonctions',
        'guide-account': 'À propos du compte',
        'guide-vehicle': 'À propos du véhicule',
        'guide-meterSetting': 'Comment configurer le tableau de bord',
        'guide-vehicleSetting': 'Comment configurer le véhicule',
        'guide-findNavigation': `Comment naviguer pour trouver le véhicule`,
        'guide-vehicleNnavigation': 'Comment utiliser la navigation',
        'guide-cyclingRecord': `À propos de l'historique de conduite`,
        'guide-vehicleExperience': 'Comment effectuer une auto-inspection du véhicule',
        'guide-useSetting': `Comment définir les paramètres généraux de l'APP`,
        'guide-notice': 'Comment afficher et définir la notification des messages',
        'guide-about': `À propos de l'application`,
        help: 'Aide et commentaires',
        'help-detail': 'Détails des questions',
        'myCar-unbinding': 'Appliquer la déliaison',
        'myCar-unbinding-result': 'Appliquer la déliaison',
      },
    },
    form: {
      cancel: 'Annuler',
      confirm: 'Confirmer',
      submit: 'Soumettre',
      search: 'Recherche',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Protocole`,
      text1: '1.	Services télématiques',
      text2:
        'CFMOTO Powersports, Inc. (ci-après dénommé « CFMOTO » ) fournit des services télématiques de véhicule au client qui a acheté le véhicule CFMOTO (ci-après dénommé « Client » ). Pour ces services, CFMOTO utilise des données enregistrées par le Véhicule concernant le Véhicule et son comportement de conduite dans la période concernée. Dans le détail, cela concerne les données suivantes :',
      text3: `Données sur le comportement de conduite de l'utilisateur : y compris l'accélération, la décélération, la vitesse, la flexion, le dernier temps de conduite et le dernier kilométrage parcouru .`,
      text4: `Données sur l'état du véhicule : se réfèrent à l'état en temps réel du véhicule, y compris le mode de conduite, le carburant résiduel, l'économie de carburant instantanée, le kilométrage, le rapport en temps réel du véhicule, la vitesse du moteur, la pression des pneus, la température des pneus, les données de tension d'activation de la batterie , température du liquide de refroidissement, état de la serrure électronique, version du logiciel de l'appareil intelligent, force du signal des appareils intelligents, réglage actuel du tableau de bord.`,
      text5: `Données d'alarme du véhicule : données d'alarme à envoyer si certaines données dépassent une valeur prédéfinie, telles que la température du moteur, une vitesse excessive, un temps de conduite excessif, une température élevée du liquide de refroidissement, un mouvement anormal du véhicule, une pression anormale des pneus, des vibrations, un déversement, une collision , etc. .`,
      text6: 'Informations sur les défauts du véhicule : fait référence aux codes de défaut signalés par chaque partie interne du véhicule.',
      text7: 'Données de localisation du véhicule : fait référence à la localisation géographique spécifique du véhicule.',
      text8: `1.1.	Fournir _ le client avec des services liés au véhicule via l' application CFMOTO RIDE .`,
      text9: `1.1.1.	Les consommateurs peuvent gérer à distance les véhicules via l' application CFMOTO RIDE (y compris la visualisation de l'emplacement du véhicule, la définition des informations et des fonctions du véhicule, la télécommande de l'état du véhicule, etc.).`,
      text10: `1.1.2.	Fournir une planification d'itinéraire pendant la navigation, y compris le calcul de la distance entre les véhicules et la navigation à pied dans le but de trouver un véhicule .`,
      text11: '1.2.	Envoi des notifications nécessaires au Client en fonction des conditions du véhicule.',
      text12: `1.2.1.	CFMOTO mettra fin aux notifications du client sur l'entretien du véhicule (par exemple, en fonction de la distance totale parcourue par le client, de l'heure à laquelle le client achète le véhicule, des exigences de temps ou de distance de conduite pour l'entretien du véhicule) .`,
      text13: `1.2.2.	Sur la base des données du véhicule , CFMOTO enverra au Client des notifications de situation anormale ; y compris l'analyse des données par OEM (selon le modèle) pour fournir un service client et un suivi de l'optimisation du véhicule .`,
      text14: `1.3.	Assistance dans l'analyse de la cause de l'accident si le Client signale un accident grave du Véhicule.`,
      text15: `1.3.1.	En cas d'accident grave du Véhicule, tel que lorsque le Véhicule se renverse ou se renverse sur le côté pendant la conduite, CFMOTO assistera le Client sur demande pour clarifier si l'accident est dû à un défaut du Véhicule ou à d'autres circonstances. La demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.`,
      text16: `1.3.2.	Dans la mesure où les données disponibles le permettent, CFMOTO évaluera les données par rapport à la cause de l'accident et fournira au Client un rapport correspondant.`,
      text17: '1.4.	Assistance au Client pour récupérer le Véhicule après la perte du Véhicule .',
      text18: `1.4.1.	Si le Véhicule est perdu, CFMOTO fournira au Client les données de localisation du Véhicule et d'autres données utiles sur l'état du Véhicule (telles que l'emplacement de la dernière activation, l'état actuel du véhicule, etc.) sur demande et si disponibles.`,
      text19: '1.4.2.	La demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.',
      text20: '1.5.	Signalement des problèmes après-vente .',
      text21: `1.5.1.	CFMOTO collecte à distance les notifications de code d'erreur envoyées par le Véhicule en cas de dysfonctionnement de ses composants et fournit les informations respectives à la demande du Client directement au Client.`,
      text22: '1.5.2.	La demande doit être soumise à CFMOTO par le Client via le distributeur/partenaire commercial local indiqué dans le Contrat de Vente de Véhicule.',
      text23: '2.	Restrictions et exclusions de service',
      text24:
        '2.1.	Il est expressément précisé que des modifications structurelles ou autres modifications techniques du Véhicule peuvent limiter la fourniture des services ou même la rendre impossible, puisque les services dépendent de la fourniture correcte des données du véhicule.',
      text25: '2.2.	Lorsque ces services ne peuvent pas être fournis en raison de la performance des données de tiers ou des réseaux de télécommunication, toute responsabilité de CFMOTO est exclue.',
      text26: '3.	Confidentialité',
      text27:
        'CFMOTO respectera les réglementations applicables en matière de protection des données lors du traitement des données personnelles en rapport avec le véhicule CFMOTO . Les termes de la politique de confidentialité de C FMOTO sont définis dans cette APPLICATION CFMOTO RIDE . En complément de la politique de confidentialité , cette notice est conforme à la politique de confidentialité . Et le Client peut se référer à la politique de confidentialité pour certains contenus liés au traitement des données non couverts par la présente notice.',
      text28: '4.	Service Clients',
      text29: `4.1.	Le client peut se sentir libre d'envoyer des questions, commentaires ou préoccupations liés à la confidentialité à CFMOTORIDEAPP@cfmotousa.com ou écrire à : CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Le client peut également appeler Relations avec la clientèle de CFMOTO au (888) 823-6686. `,
      text30: '5.	Révisions _',
      text31: '5.1.	CFMOTO se réserve le droit de modifier cet avis à tout moment, mais nous publierons les révisions sur CFMOTO RIDE App et/ou fournir un avis avant que nous ne le fassions, le cas échéant.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Les nouveaux paramètres prendront effet dans les 1 à 3 minutes après la mise sous tension du véhicule, veuillez vous assurer que le véhicule est dans une bonne position de signal',
      setSuccess: 'Réglage effectué avec succès',
      sure: 'Bien sûr',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      cContent: `Les paramètres n'ont pas encore été enregistrés, voulez-vous les enregistrer ?`,
      save: 'Enregistrer les paramètres',
      introduce1: 'Instructions de déverrouillage quasi automatique',
      introduce2: 'instructions de mise hors tension automatique',
      introduce3: 'Instructions de réveil automatique',
      introduce4: 'Lumières retardées',
      content1: {
        msg1: `Une fois la fonction activée, le téléphone mobile allume le Bluetooth et l'application continue de fonctionner. Lorsque vous approchez du véhicule de loin en près, le véhicule peut être automatiquement déverrouillé et mis sous tension.`,
        msg2: `S'il n'est pas normalement déverrouillé et mis sous tension, appuyez sur le bouton d'alimentation du véhicule pour le déverrouiller et le mettre sous tension`,
        msg3: `Le déverrouillage automatique de proximité ne sera déclenché qu'une seule fois avant la déconnexion Bluetooth`,
      },
      content2: {
        msg1: `Após a função ser ligada, o veículo desligará automaticamente após 5 segundos após as três condições do veículo serem desligadas, a velocidade do veículo é 0 e O templo caiu`,
        msg2: `Iniciar o veículo durante o período de desligamento automático, a velocidade do veículo não é 0 ou a têmpora é colocada cancelará o desligamento automático ...`,
      },
      content3: {
        msg1: `Une fois la fonction activée, lorsque le véhicule est éteint, le téléphone mobile allume le Bluetooth et l'application continue de fonctionner ou porte la clé physique. Lorsque vous approchez du véhicule de loin en près, les feux du véhicule clignotent pour accueillir les invités`,
        msg2: `Afin d'éviter que des déclenchements fréquents ne provoquent une perte de puissance du véhicule, après le déclenchement de la fonction d'accueil deux fois dans les 30 secondes, elle ne reprendra que 30 minutes plus tard`,
      },
      content4: {
        msg1: `Une fois la fonction activée, les feux de croisement et de loin s'allument automatiquement pendant 10 secondes après la mise hors tension du véhicule.`,
      },
    },
    feedback: {
      label: {
        type: 'Type de rétroaction (choix unique)',
        content: 'Description du problème',
        fileList: 'Veuillez télécharger une photo',
        fileList2: '(Maximum 4 photos / 1 vidéo)',
        feedbackCreate: 'Cliquez sur les commentaires',
        feedbackSupplement: 'Commentaires supplémentaires',
        backHome: "Retour à la page d'accueil",
        vehicle: 'véhicule associé',
        selectVehicle: 'sélectionner un véhicule',
      },
      placeholder: {
        'content.bug':
          "Veuillez décrire en détail l'heure à laquelle le problème s'est produit, la version de l'APP, le modèle de téléphone portable, le chemin d'exploitation et la description du problème afin d'aider à localiser et à résoudre rapidement le problème",
        'content.suggest': 'Nous vous invitons à nous faire part de vos suggestions, nous examinerons sérieusement vos idées.',
        'content.vehicle': "Veuillez décrire quand cela s'est produit, comment cela s'est produit et le problème.",
        'content.other': "Veuillez décrire quand cela s'est produit, comment cela s'est produit et le problème.",
        'content.supplement': 'Veuillez ajouter une description du problème',
        vehicle: 'Veuillez sélectionner un véhicule',
      },
      rules: {
        'type.required': 'Veuillez sélectionner un type de réaction',
        'content.required': 'Por favor introduza uma descrição do seu problema',
        'fileList.uploading': 'Téléchargement, veuillez patienter',
        'fileList.maxSize': 'Le fichier téléchargé est trop grand',
        'fileList.overType': 'Formats non pris en charge',
        'fileList.maxCount': 'Le nombre de téléchargements dépasse la limite',
        'fileList.acceptImageVideo': 'La vidéo ne peut pas être sélectionnée lors de la sélection des images',
        'vehicle.required': 'Veuillez sélectionner un véhicule',
      },
      message: {
        empty: 'Neste momento não há registos de feedback~',
        finish: 'Tout ici',
        loading: 'Chargement',
        uploadFailed: 'Impossible de télécharger',
        tip: "Pour protéger la sécurité de votre compte, veuillez ne pas soumettre d'informations personnelles sensibles ici, telles que les mots de passe des comptes, etc.",
        feedbackSuccess: 'Commentaires reçus',
        'submit.error': 'Échec de la rétroaction',
        'submit.success': 'Commentaires reçus',
      },
    },
    guide: {
      label: { giveFeedback: 'Non résolu, je veux donner des commentaires' },
    },
    help: {
      label: {
        history: 'Rechercher des enregistrements',
        cancel: 'Annuler',
        yes: 'Oui',
        no: 'Non',
        unresolved: 'Vous ne pouvez toujours pas résoudre ? Cliquez sur',
        submitFeedback: 'Soumettre des commentaires',
      },
      placeholder: {
        search: 'Recherche',
        'content.required': 'Veuillez entrer un mot-clé',
      },
      message: {
        empty: 'Aucun contenu associé',
        empty2: 'Suggérer de changer de mots-clés ou',
        finish: 'Tout ici',
        historyDelete: 'Supprimer tous les enregistrements de recherche ?',
        isHelpful: 'Aide-t-il?',
      },
    },
    unbinding: {
      label: {
        vin: "N° d'identification ",
        realName: 'Nom et prénom',
        email: 'Adresse e-mail',
        phone: 'Numéro de téléphone',
        areaCode: 'Code pays',
        identity: 'Identification',
        drivingLicense: "Certificat d'immatriculation du véhicule",
        backHome: "Retour à la page d'accueil",
        areaCodeTitle: 'Code du pays',
        latterTitle: 'Avis',
        agree: 'Approbation',
        disagree: "Pas d'accord",
        agreeCheckLabel: "J'ai lu et j'accepte",
        agreeCheckTitle: 'Instructions pour demander la déliaison du véhicule',
      },
      placeholder: {
        vin: 'Veuillez saisir le VIN',
        realName: 'Veuillez saisir votre vrai nom',
        email: 'Veuillez saisir votre adresse e-mail',
        phone: 'Veuillez saisir votre numéro de téléphone',
        identity: "Page principale de la carte d'identité, du permis de conduire ou du passeport contenant des informations d'identification personnelle",
        drivingLicense: "Page principale du certificat d'immatriculation avec le nom du propriétaire et le numéro d'identification du véhicule.",
      },
      rules: {
        'agree.required': 'Veuillez lire et accepter',
        'vin.required': 'Veuillez saisir le VIN',
        'vin.pattern': 'Mauvais numéro de VIN, veuillez vérifier.',
        'realName.required': 'Veuillez saisir votre vrai nom',
        'email.required': 'Veuillez saisir votre adresse e-mail',
        'email.pattern': "Le format de l'adresse e-mail est incorrect, veuillez vérifier",
        'phone.required': 'Veuillez saisir votre numéro de téléphone',
        'phone.pattern': 'Erreur de format du numéro de téléphone, veuillez vérifier',
        'fileList.maxCount': 'Le nombre de téléchargements dépasse la limite',
        'fileList.uploading': 'Téléchargement, veuillez patienter',
      },
      message: {
        imgUploadFailed: 'Échec du téléchargement de la photo',
        securityMessage: "Les informations ci-dessus sont utilisées pour la vérification de l'identité uniquement. CFMOTO protège vos informations.",
        resultMessage: 'Nous vérifierons les documents de candidature dès que possible, veuillez faire attention à la barre de notification ou au centre de messagerie APP à temps.',
        loading: 'Chargement',
      },
    },
  },
};
